import {useEffect, useState} from "react";
import {list as listDecks} from "custom/demo/requests/admin/decks";
import {create, destroy, get, update} from "custom/demo/requests/admin/organizations";
import Field from "components/helpers/form/field";
import useForm from "custom/demo/helpers/admin/use-form";

const defaults = {
  deck_id: "",
  email_results: false,
  facebook_app_id: "",
  facebook_app_secret: "",
  logo: "",
  name: "",
  public_key: "",
  reset_session: false,
  secret_key: "",
  show_notice: false,
  show_stats: false,
  subdomain: ""
};

export default function Form() {
  const {id, onChange, onDestroy, onSubmit, record} = useForm({
    actions: {create, destroy, get, update}, defaults, path: "/admin/organizations"
  });
  const [deckOptions, setDeckOptions] = useState([]);

  useEffect(() => {
    listDecks().then((data) => {
      setDeckOptions(data.records.map((deck) => ({name: deck.name, value: deck.key})));
    });
  }, []);

  return (
    <div className="container">
      <h1>Organization</h1>
      <form onSubmit={onSubmit}>
        <Field
          label="Name"
          name="name"
          onChange={onChange}
          placeholder="Name"
          required={true}
          value={record.name}
        />
        <Field
          label="Subdomain"
          name="subdomain"
          onChange={onChange}
          placeholder="Subdomain"
          required={true}
          value={record.subdomain}
        />
        <Field
          label="Logo"
          name="logo"
          onChange={onChange}
          placeholder="Logo"
          value={record.logo}
        />
        <Field
          label="Deck"
          name="deck_id"
          onChange={onChange}
          options={deckOptions}
          placeholder="None"
          type="select"
          value={record.deck_id || ""}
        />
        <Field
          checked={record.email_results}
          label="Email Results"
          name="email_results"
          onChange={onChange}
          type="checkbox"
        />
        <Field
          checked={record.reset_session}
          label="Reset Session"
          name="reset_session"
          onChange={onChange}
          type="checkbox"
        />
        <Field
          checked={record.show_notice}
          label="Show Notice"
          name="show_notice"
          onChange={onChange}
          type="checkbox"
        />
        <Field
          checked={record.show_stats}
          label="Show Stats"
          name="show_stats"
          onChange={onChange}
          type="checkbox"
        />
        <Field
          label="Facebook App ID"
          name="facebook_app_id"
          onChange={onChange}
          placeholder="Facebook App ID"
          value={record.facebook_app_id}
        />
        <Field
          label="Facebook App Secret"
          name="facebook_app_secret"
          onChange={onChange}
          placeholder="Facebook App Secret"
          value={record.facebook_app_secret}
        />
        <Field
          label="Traitify Public Key (leave blank for default)"
          name="public_key"
          onChange={onChange}
          placeholder="Traitify Public Key"
          value={record.public_key}
        />
        <Field
          label="Traitify Secret Key (leave blank for default)"
          name="secret_key"
          onChange={onChange}
          placeholder="Traitify Secret Key"
          value={record.secret_key}
        />
        <div className="flex gap-2 mt-4">
          <button className="btn btn-blue" type="submit">Save</button>
          {id && <button className="btn btn-red" onClick={onDestroy} type="button">Delete</button>}
        </div>
      </form>
    </div>
  );
}
